import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
  name: 'dist'
} )
export class DistancePipe implements PipeTransform {
  transform ( item: number, type?: string ) {

    if ( type == 'km' ) {
      return (item / 1000).toFixed(2);
    } else {
      return item.toFixed(2);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/distance.pipe.ts